module.exports = __webpack_public_path__ + "static/media/YF94_5.1ebe39bd.jpg";